import type { ElementType } from 'react';
import type { SxProps, Theme } from '@mui/material/styles';
import Link from '@mui/material/Link';
import { styled } from '@mui/material/styles';

// ----------------------------------------------------------------------

type MoreLinksRootProps = React.ComponentProps<'ul'> & {
  sx?: SxProps<Theme>;
};

export type MoreLinksProps = MoreLinksRootProps & {
  links?: string[];
};

export function MoreLinks({ links, sx, ...other }: MoreLinksProps) {
  return (
    <MoreLinksRoot sx={sx} {...other}>
      {links?.map((href) => (
        <li key={href}>
          <Link href={href} variant="body2" target="_blank" rel="noopener noreferrer">
            {href}
          </Link>
        </li>
      ))}
    </MoreLinksRoot>
  );
}

// ----------------------------------------------------------------------

const MoreLinksRoot: ElementType = styled('ul')(() => ({
  display: 'flex',
  flexDirection: 'column',
  '& > li': { display: 'flex' },
}));
